export default __webpack_public_path__ + "static/media/NtorqueRacing.425d7afc.webp";